export const downloadCSVFromBlob = (data: Blob) => {
  const blob = new Blob([data], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'data.csv';
  a.click();
  window.URL.revokeObjectURL(url);
};
